import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// S15 09/08 — filet global anti écran blanc : toute erreur de rendu non
// rattrapée affiche un panneau explicite au lieu d'une page morte.
import { AppErrorBoundary } from "@/components/AppErrorBoundary";

// Suppress browser extension errors (Firefox __firefox__, Chrome extensions)
window.addEventListener('error', (e) => {
  if (e.message && (e.message.includes('__firefox__') || e.message.includes('playlistLongPressed') || e.message.includes('Script error'))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
